export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    BaseReport: [
      'DetailedDataReport',
      'Report',
      'StandardDeliveryDeviceHigherCategoryReport',
      'StandardDeliveryReport',
    ],
    BrunoBaseReport: [
      'AllCampaignsCreateReportResponse',
      'AllCampaignsReport',
      'BrunoCreateDetailedReportReportResponse',
      'BrunoDetailedReportReport',
    ],
    Connection: [
      'AdAccountsOptionsPages',
      'AdAccountsOptionsWithNotificationTypesPages',
      'AdAccountsPages',
      'AdsList',
      'BillingContactsPage',
      'BrandsPage',
      'BroadcastPage',
      'BroadcastersList',
      'BrunoDetailedReportsPage',
      'BrunoReportsPage',
      'CampaignsOptions',
      'CampaignsPage',
      'CampaignsPageWithExtraData',
      'CampaignsShortInfoPage',
      'GetUsersPage',
      'InvoicePage',
      'LateLinesPage',
      'NotificationPage',
      'OrganizationsList',
      'PaymentsList',
      'SearchUsersPage',
      'StandardDeliveryDeviceHigherCategoryReportMetricsPage',
      'StandardDeliveryReportMetricsPage',
      'TransactionHistoryPage',
      'UsersPage',
    ],
    Edge: [
      'AdAccountEdge',
      'AdAccountOptionsEdge',
      'AdAccountOptionsWithNotificationTypeEdge',
      'AdEdge',
      'BillingContactEdge',
      'BrandEdge',
      'BroadcastEdge',
      'BroadcasterEdge',
      'BrunoDetailedReportEdge',
      'BrunoReportEdge',
      'CampaignEdge',
      'CampaignEdgeWithExtraData',
      'CampaignOptionsEdge',
      'CampaignShortInfoEdge',
      'GetUsersEdge',
      'InvoiceEdge',
      'LateLineEdge',
      'NotificationEdge',
      'OrganizationEdge',
      'PaymentsEdge',
      'SearchUserEdge',
      'StandardDeliveryDeviceHigherCategoryReportMetricsEdge',
      'StandardDeliveryReportMetricsEdge',
      'TransactionHistoryEdge',
      'UserEdge',
    ],
    EntityName: ['AdAccountRole', 'GenericRole'],
    LineItemInterface: ['InfoMetricsLineItem', 'LineItem'],
    Node: [
      'AdAccount',
      'AdAccountOptions',
      'AdAccountWithNotificationTypeOptions',
      'AdInfo',
      'Audiences',
      'BillingContact',
      'Brand',
      'Broadcast',
      'Broadcaster',
      'BrunoDetailedReportInfo',
      'BrunoReportInfo',
      'CampaignInfo',
      'CampaignInfoWithExtraData',
      'CampaignOption',
      'CampaignShortInfo',
      'GetUsersNode',
      'Invoice',
      'LateLine',
      'Notification',
      'OrganizationListItem',
      'PaymentMethod',
      'SearchUser',
      'StandardDeliveryDeviceHigherCategoryReportMetrics',
      'StandardDeliveryReportMetrics',
      'TransactionHistory',
      'User',
    ],
    ReportFilters: [
      'DetailedDataReportFilters',
      'StandardDeliveryDeviceHigherCategoryReportFilters',
      'StandardDeliveryReportFilters',
    ],
    SharedStandardDeliveryReportFilters: [
      'StandardDeliveryDeviceHigherCategoryReportFilters',
      'StandardDeliveryReportFilters',
    ],
    VastInterface: ['QCheckVast'],
  },
};
export default result;
